import React from "react";
import "../../assets/css/why.css";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";

export default function WhyChoose() {

  const features = [
    "Complete Travel Management",
    "Budget-Friendly Packages",
    "Trusted Since 2023",
    "Expert Team Support",
    "Safe & Comfortable Travel"
  ];

  return (
    <section className="whyNew">

      <div className="whyNew-container">

        {/* LEFT SIDE */}
        <motion.div 
          className="why-left"
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Why Choose <span>Trip Word?</span>
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            We don’t just plan trips — we create experiences. 
            Every journey is crafted with care, comfort, and unforgettable memories.
          </motion.p>

          <motion.button 
            className="why-btn"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >

              <NavLink  to="/gallery"   style={{ textDecoration: "none",color:"white" }}>
               Explore More →

  </NavLink>
          </motion.button>
        </motion.div>

        {/* RIGHT SIDE TIMELINE */}
        <div className="why-right">
          {features.map((item, i) => (
            <motion.div 
              className="why-step"
              key={i}
              initial={{ opacity: 0, x: 80 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.2, duration: 0.6 }}
            >
              <motion.div 
                className="circle"
                whileHover={{ scale: 1.3, rotate: 10 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                {i + 1}
              </motion.div>

              <motion.div 
                className="line"
                initial={{ height: 0 }}
                whileInView={{ height: 40 }}
                transition={{ delay: i * 0.2 }}
              ></motion.div>

              <motion.h3
                whileHover={{ x: 10 }}
              >
                {item}
              </motion.h3>
            </motion.div>
          ))}
        </div>

      </div>

    </section>
  );
}